import React from "react";
import clsx from "clsx";

export function Button({
  isLoading,
  onClick,
  text,
  className = "",
  shape = "default", // default | oval | round
  ...rest
}) {
  const baseClasses = clsx(
    "text-white font-semibold text-base flex items-center justify-center gap-2",
    "transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed",
    "bg-gradient-to-br from-[#0052FF] to-[#0099FF]",
    "hover:scale-[1.03] hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
    {
      "rounded-xl px-6 py-3 inline-flex": shape === "default",
      "rounded-full px-8 py-3.5 inline-flex": shape === "oval",
      "rounded-full p-4 inline-flex": shape === "round",
    },
    className
  );

  return (
    <button
      type="button"
      className={baseClasses}
      onClick={onClick}
      disabled={isLoading}
      {...rest}
    >
      {isLoading ? (
        <div className="flex items-center justify-center gap-3">
          <span className="w-5 h-5 border-4 border-white border-t-transparent rounded-full animate-spin" />
          <span className="opacity-90">{text || "Loading..."}</span>
        </div>
      ) : (
        <span>{text}</span>
      )}
    </button>
  );
}
